import { render, staticRenderFns } from "./OrderProperty.vue?vue&type=template&id=123f9b50&scoped=true"
import script from "./OrderProperty.vue?vue&type=script&lang=js"
export * from "./OrderProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123f9b50",
  null
  
)

export default component.exports